import { render, staticRenderFns } from "./MobileFrame.vue?vue&type=template&id=04d1b23f&scoped=true&"
import script from "./MobileFrame.vue?vue&type=script&lang=js&"
export * from "./MobileFrame.vue?vue&type=script&lang=js&"
import style0 from "./MobileFrame.vue?vue&type=style&index=0&id=04d1b23f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d1b23f",
  null
  
)

export default component.exports